import Vue from 'vue'
import {
  RECEIVE_REPORT_OPTIONS,
  CLEAR_REPORT_OPTIONS,
  RECEIVE_FORM_FIELDS,
  CLEAR_STATE
} from '../mutationTypes'
import { checkStatus, getHeaders, parseJSON, buildUrlWithQuery } from '@/utils/api'
import { createFields, clearState } from '@/store/modules/helpers/mutationHelpers'

const state = {
  fields: {},
  reportOptions: {},
  receivingFieldsFailure: '',
  lastUpdated: {}
}

const actions = {
  fetchFormFields (store, endpoint) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    return Vue.http({ url: buildUrlWithQuery(endpoint, {}, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(r => {
        if (!r && r.hasOwnProperty('parameters')) return Promise.reject({ msg: 'Error fetching report parameters', response: r })
        this.commit(RECEIVE_REPORT_OPTIONS, { endpoint, data: r })
        return r
      })
      .catch(e => {
        console.log(e)
        return e
      })
  },
  clearFormFields (store, endpoint) {
    this.commit(CLEAR_REPORT_OPTIONS, endpoint)
  }
}

const getters = {
  getReportFormFields: (state) => (endpoint) => {
    return state.reportOptions[endpoint] ? state.reportOptions[endpoint].parameters : {}
  },
  getReportOptions: (state) => (endpoint) => state.reportOptions[endpoint],
  getResourceFieldsByEndpoint: (state) => (endpoint) => {
    return state.fields[endpoint]
  },
  getFormFieldsOfTypeMany: (state) => (fieldGroup) => {
    let ret = {}
    if (state.reportOptions[fieldGroup] && state.reportOptions[fieldGroup].parameters) {
      const group = Object.assign({}, state.reportOptions[fieldGroup].parameters)
      for (let f in group) {
        if (group[f].hasOwnProperty('many') && group[f].many) {
          ret[f] = group[f]
        }
      }
    }
    return ret
  },
  getLastUpdated (state) {
    return state.lastUpdated
  }
}

const mutations = {
  [RECEIVE_REPORT_OPTIONS] (state, payload) {
    if (!payload || !Object.keys(payload).length) return state.data
    const { endpoint, data } = payload
    let tmpData = Object.assign({}, state.reportOptions)
    if (tmpData[endpoint] && Object.keys(tmpData[endpoint]).length) {
      tmpData[endpoint] = Object.assign({}, tmpData[endpoint], data)
    } else {
      tmpData[endpoint] = data
    }
    state.reportOptions = Object.assign({}, tmpData)
    let tmpUpdated = Object.assign({}, state.lastUpdated)
    tmpUpdated[endpoint] = Math.round((new Date()).getTime() / 1000)
    state.lastUpdated = Object.assign({}, tmpUpdated)
  },
  [CLEAR_REPORT_OPTIONS] (state, endpoint) {
    let tmpData = { ...state.reportOptions }
    if (tmpData[endpoint]) {
      delete tmpData[endpoint]
    }
    state.reportOptions = { ...tmpData }
    let tmpUpdated = { ...state.lastUpdated }
    if (tmpUpdated[endpoint]) {
      delete tmpUpdated[endpoint]
    }
    state.lastUpdated = { ...tmpUpdated }
  },
  [RECEIVE_FORM_FIELDS] (state, { endpoint, fields }) {
    createFields(state, { endpoint, fields })
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/fields.js